import Sloth from 'slothd/dist/Sloth';
import './popup.scss';

@Sloth.component({
    defaultOptions:{
        option: 'option'
    }
})

export default class Popup {
    onInit() {
        const options = this.options;
        const dom = this.dom;

        // hide
        $('.close', dom).on('click', () => {
            $(dom).hide();
        });

        if (options.type === 'button') {
            $(dom).on('click', () => {
                $(options.opendom).show();
                if (options.index) {
                    const component = $('.Carousel', options.opendom)[0].component;
                    $('ul', component.dom).trigger('slideTo', options.index - 1);
                    $('ul', component.dom).trigger('updateSizes');
                }
            });
        }
    }
}



/** WEBPACK FOOTER **
 ** ./components/Popup/popup.js
 **/